<template>
  <div class="form-container mt-2">
    <div class="wrapper">
      <fields :detail="detail" />
      <b-row>
        <b-col cols="6">
          <b-form-group
            label="Job Desc"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-textarea
              v-model="detail.job_desc"
              rows="3"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <b-table
      thead-class="bg-color text-center"
      :sticky-header="stickyHeader"
      :no-border-collapse="noCollapse"
      responsive
      :items="detail.detail"
      :fields="fields"
      empty-text="No data"
      show-empty
    >
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner
            variant="info"
            class="spinner-lg"
          />
        </div>
      </template>
      <template #head()="scope">
        <div class="text-nowrap" style="width: 120px">
          {{ scope.label }}
        </div>
      </template>
      <template #head(type)="scope">
        <div class="text-nowrap">{{ scope.label }}</div>
      </template>
      <template v-slot:cell(type)="data">
        <span class="font-weight-bolder">
          {{ data.item.type === 'Varian' ? data.item.type + ' (%)' : data.item.type.replace('_', ' ') }}
        </span>
      </template>
      <template v-slot:cell(jan)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.jan.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.jan"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('jan')"
        />
      </template>
      <template v-slot:cell(feb)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.feb.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.feb"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('feb')"
        />
      </template>
      <template v-slot:cell(mar)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.mar.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.mar"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('mar')"
        />
      </template>
      <template v-slot:cell(apr)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.apr.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.apr"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('apr')"
        />
      </template>
      <template v-slot:cell(may)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.may.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.may"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('may')"
        />
      </template>
      <template v-slot:cell(jun)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.jun.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.jun"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('jun')"
        />
      </template>
      <template v-slot:cell(jul)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.jul.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.jul"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('jul')"
        />
      </template>
      <template v-slot:cell(aug)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.aug.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.aug"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('aug')"
        />
      </template>
      <template v-slot:cell(sep)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.sep.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.sep"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('sep')"
        />
      </template>
      <template v-slot:cell(oct)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.oct.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.oct"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('oct')"
        />
      </template>
      <template v-slot:cell(nov)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.nov.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.nov"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('nov')"
        />
      </template>
      <template v-slot:cell(dec)="data">
        <span v-if="data.item.type != 'plan'">{{ data.item.dec.toLocaleString('en-US') }}</span>
        <b-form-input
          v-if="data.item.type === 'plan'"
          autocapitalize="off"
          v-model="data.item.dec"
          size="sm"
          type="number"
          autocomplete="off"
          @blur="reCalculate('dec')"
        />
      </template>
    </b-table>
    <div class="d-flex mt-5">
      <b-button
        class="btn-reset mr-2 ml-auto"
        variant="outline-info"
        size="sm"
        @click="onClickCancel"
      >
        Cancel
      </b-button>
      <b-button
        class="btn-custom"
        variant="info"
        size="sm"
        @click="onClickSubmit"
        :disabled="isLoading"
      >
        Submit
      </b-button>
    </div>
    <modal-successful :message="text" />
  </div>
</template>

<script>
import api from '@/api'
import Fields from './Field'
import ModalSuccessful from '@/partials/ModalSuccessful'

export default {
  components: {
    Fields,
    ModalSuccessful
  },

  data: () => ({
    text: '',
    stickyHeader: true,
    noCollapse: false,
    fields: [
      { key: 'type', stickyColumn: true, label: 'Type', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'jan', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'feb', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'mar', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'apr', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'may', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'jun', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'jul', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'aug', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'sep', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'oct', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'nov', tdClass: 'text-center', thStyle: 'width: 120px' },
      { key: 'dec', tdClass: 'text-center', thStyle: 'width: 120px' }
    ],
    detail: {},
    isLoading: false
  }),

  created() {
    this.fetctDetailBudget()
  },

  methods: {
    async fetctDetailBudget() {
      const data = await api.budget.get(this.$route.params.id)
      this.detail = data
      const plan = this.detail.detail.find(d => d.type === 'plan')
      const actual = this.detail.detail.find(d => d.type === 'actual')
      this.detail.detail = [
        plan,
        actual,
        {
          type: 'variant',
          ...this.fields.reduce((rv, item) => {
            rv[item.key] = plan[item.key] - actual[item.key]
            return rv
          })
        },
        {
          type: 'variant (%)',
          ...this.fields.reduce((rv, item) => {
            rv[item.key] = (plan[item.key] - actual[item.key]) / plan[item.key] * 100
            return rv
          })
        }
      ]
    },
    onClickCancel() {
      this.$router.push({ path: '/budget-plan' })
    },
    async onClickSubmit() {
      try {
        this.isLoading = true
        const plan = this.detail.detail[0]
        delete plan.id
        delete plan.type
        await api.budget.saveBudget(this.$route.params.id, { job_desc: this.detail.job_desc, ...plan })
        this.text = 'edit budget plan'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          this.$router.push({ path: `/budget-plan/${this.$route.params.id}/detail` })
        }, 1500)
      } catch ({ response }) {
        this.isLoading = false
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async reCalculate(column) {
      if (this.detail.detail[0][column] === '') {
        this.detail.detail[0][column] = 0
      }
      this.detail.detail[2][column] = this.detail.detail[0][column] - this.detail.detail[1][column]
      if (parseFloat(this.detail.detail[0][column]) === 0) {
        this.detail.detail[3][column] = 0
      } else {
        this.detail.detail[3][column] = (this.detail.detail[0][column] - this.detail.detail[1][column]) / (this.detail.detail[0][column] === 0 ? 1 : this.detail.detail[0][column]) * 100
      }
    }
  },

  destroyed() {
    localStorage.removeItem('currentPage', this.currentPage)
    localStorage.removeItem('totalRows', this.totalRows)
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}

.col-form-label, .col-form-label-sm {
  font-size: 12px !important;
}
</style>
